export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13904.5379fb29.jpg";